var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.658 30.917c0-8.328 0-12.492 2.6-15.08 2.6-2.587 6.786-2.587 15.157-2.587h8.878c8.37 0 12.556 0 15.156 2.587 2.6 2.588 2.6 6.752 2.6 15.08s0 12.492-2.6 15.08c-2.6 2.587-6.786 2.587-15.156 2.587h-8.878c-8.371 0-12.556 0-15.157-2.588-2.6-2.587-2.6-6.751-2.6-15.08ZM35.732 13.25c0-4.164 0-6.246-1.3-7.54-1.3-1.293-3.393-1.293-7.578-1.293-4.186 0-6.278 0-7.578 1.293-1.3 1.294-1.3 3.376-1.3 7.54",
    stroke: "#fff",
    strokeWidth: 3.313
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.854 38.278c2.451 0 4.439-1.648 4.439-3.68 0-2.033-1.988-3.681-4.44-3.681-2.451 0-4.439-1.648-4.439-3.68 0-2.033 1.988-3.681 4.44-3.681m0 14.722c-2.452 0-4.44-1.648-4.44-3.68m4.44 3.68v1.472m0-16.194v-1.473m0 1.473c2.451 0 4.439 1.648 4.439 3.68",
    stroke: "#fff",
    strokeWidth: 3.313,
    strokeLinecap: "round"
  })));
};
export default SvgBag;